import angular from "angular";
import { PayrollInvoiceDashboardContainerComponent } from "./dashboard/payroll-invoice-dashboard-container.component";
import { payrollInvoiceDashboardItemTemplate, payrollInvoiceDashboardListItemTemplate } from "./dashboard/payroll-invoice-dashboard-item-templates.block";
import { PayrollInvoiceDashboardComponent } from "./dashboard/payroll-invoice-dashboard.component";
import { EditPayrollInvoicePolicyModalComponent } from "./edit-payroll-invoice-policy/edit-payroll-invoice-policy-modal.component";
import { PayrollInvoiceGeneratorContainerComponent } from "./payroll-invoice-generator/payroll-invoice-generator-container.component";
import { PayrollInvoiceGeneratorComponent } from "./payroll-invoice-generator/payroll-invoice-generator.component";
import { PayrollInvoiceListComponent } from "./payroll-invoice-list/payroll-invoice-list.component";
import { PayrollInvoicePolicyListComponent } from "./payroll-invoice-policy-list/payroll-invoice-policy-list.component";
import { PayrollInvoicingRoutingModule } from "./payroll-invoicing-routing.module";

/** A module representing invoice activity resulting from payroll services rendered. */
export const PayrollInvoicingModule = angular
    .module("apex.mainApp.payrollInvoicing", [
        PayrollInvoicingRoutingModule
    ])
    .component("apexPayrollInvoiceDashboardContainer", PayrollInvoiceDashboardContainerComponent)
    .component("apexPayrollInvoiceDashboard", PayrollInvoiceDashboardComponent)
    .component("apexEditPayrollInvoicePolicyModal", EditPayrollInvoicePolicyModalComponent)
    .component("apexPayrollInvoicePolicyList", PayrollInvoicePolicyListComponent)
    .component("apexPayrollInvoiceGeneratorContainer", PayrollInvoiceGeneratorContainerComponent)
    .component("apexPayrollInvoiceGenerator", PayrollInvoiceGeneratorComponent)
    .component("apexPayrollInvoiceList", PayrollInvoiceListComponent)
    .run(payrollInvoiceDashboardItemTemplate)
    .run(payrollInvoiceDashboardListItemTemplate)
    .name
